module.exports = __webpack_public_path__ + "static/media/auditory-icon@2x.229edc69.png";